import { AloBaseLg, getDefaultAloBaseLg } from "./AloBaseLg"


export interface AloPlatLg extends AloBaseLg  {     
    cuissons?:Array<string>,
    parfums?:Array<string>

}

export const getDefaultAloPlatLg = ():AloPlatLg => {
    return {
        ...getDefaultAloBaseLg("en")
    }
}